<template>
  <div class="bg-surface-light p-4 border-surface-grey border rounded-md flex items-start gap-2">
    <InfoIcon class="w-5 h-5 shrink-0 fill-primary mt-[2px]" />
    <p class="text-text wrap-anywhere">
      <template v-for="(segment, index) in segments" :key="index">
        <button
          v-if="segment.type === 'login'"
          type="button"
          class="underline cursor-pointer hover:text-headings"
          @click="ssoStore.login()"
        >{{ segment.text }}</button>
        <a
          v-else-if="segment.type === 'link'"
          :href="segment.href"
          target="_blank"
          rel="noopener noreferrer"
          class="underline hover:text-headings"
        >{{ segment.text }}</a>
        <span v-else>{{ segment.text }}</span>
      </template>
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useSsoStore } from '@/stores/sso';
import { parseSsoPrompt } from '@/utils/parseSsoPrompt';

import InfoIcon from '../icons/InfoIcon.vue';

const props = defineProps<{
  text: string;
}>();

const ssoStore = useSsoStore();

const segments = computed(() => parseSsoPrompt(props.text));
</script>
